/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Services_Delivery_CtaInputs */

const en_services_delivery_cta = /** @type {(inputs: Services_Delivery_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How we work together`)
};

const lv_services_delivery_cta = /** @type {(inputs: Services_Delivery_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kā mēs strādājam kopā`)
};

/**
* | output |
* | --- |
* | "How we work together" |
*
* @param {Services_Delivery_CtaInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const services_delivery_cta = /** @type {((inputs?: Services_Delivery_CtaInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Services_Delivery_CtaInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_services_delivery_cta(inputs)
	return en_services_delivery_cta(inputs)
});